import {
    CREATE_WASHING_DC_DETAILS_FAILURE_DK,
    CREATE_WASHING_DC_DETAILS_REQUEST_DK,
    CREATE_WASHING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_WASHING_DC_DETAILS_DK,
    DELETE_WASHING_DC_DETAILS_FAILURE_DK,
    DELETE_WASHING_DC_DETAILS_REQUEST_DK,
    DELETE_WASHING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_WASHING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_WASHING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_WASHING_DC_DETAILS_SUCCESS_DK,
    FETCH_WASHING_DC_DETAILS_FAILURE_DK,
    FETCH_WASHING_DC_DETAILS_REQUEST_DK,
    FETCH_WASHING_DC_DETAILS_SUCCESS_DK,
    WASHING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_WASHING_DC_DETAILS_FAILURE_DK,
    UPDATE_WASHING_DC_DETAILS_REQUEST_DK,
    UPDATE_WASHING_DC_DETAILS_SUCCESS_DK,
    FETCH_WASHING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_WASHING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_WASHING_DC_DETAILS_BY_ID_FAILURE_DK,
    FETCH_WASHING_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_WASHING_DC_PREVIOUS_LIST_SUCCESS_DK,
    FETCH_WASHING_DC_PREVIOUS_LIST_FAILURE_DK,
    FETCH_WASHING_DC_DETAILS_DC_NO_REQUEST_DK,
    FETCH_WASHING_DC_DETAILS_DC_NO_SUCCESS_DK,
    FETCH_WASHING_DC_DETAILS_DC_NO_FAILURE_DK,
    FETCH_GRN_NO_BY_WASHING_DC_NO_REQUEST_DK,
    FETCH_GRN_NO_BY_WASHING_DC_NO_SUCCESS_DK,
    FETCH_GRN_NO_BY_WASHING_DC_NO_FAILURE_DK
} from './washingDCDetails.actionsType';

export const WASHING_DC_DETAILS_DK = 'washingDcDetailsDK';

let initialState = {
    loading: false,
    washingDCDetailsById: [],
    washingDCDetails: [],
    washingDCDetailsDcNo: [],
    previousList: [],
    grnNoByWashingDcNo: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedWashingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let washingDCDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_WASHING_DC_DETAILS_REQUEST_DK:
        case FETCH_GRN_NO_BY_WASHING_DC_NO_REQUEST_DK:
        case FETCH_WASHING_DC_DETAILS_DC_NO_REQUEST_DK:
        case FETCH_WASHING_DC_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_WASHING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_WASHING_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_WASHING_DC_DETAILS_REQUEST_DK:
        case UPDATE_WASHING_DC_DETAILS_REQUEST_DK:
        case DELETE_WASHING_DC_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_WASHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingDCDetails: updatePayload
            };
        case FETCH_GRN_NO_BY_WASHING_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                grnNoByWashingDcNo: updatePayload?.Inward
            };
        case FETCH_WASHING_DC_DETAILS_DC_NO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingDCDetailsDcNo: updatePayload?.DYD
            };
        case FETCH_WASHING_DC_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_WASHING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingDCDetailsById: updatePayload
            };
        case CREATE_WASHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_WASHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedWashingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_WASHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedWashingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_WASHING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedWashingDCDetails: {}
            };

        case FETCH_WASHING_DC_DETAILS_FAILURE_DK:
        case FETCH_GRN_NO_BY_WASHING_DC_NO_FAILURE_DK:
        case FETCH_WASHING_DC_DETAILS_DC_NO_FAILURE_DK:
        case FETCH_WASHING_DC_PREVIOUS_LIST_FAILURE_DK:
        case FETCH_WASHING_DC_DETAILS_BY_ID_FAILURE_DK:
        case FETCH_SINGLE_WASHING_DC_DETAILS_FAILURE_DK:
        case CREATE_WASHING_DC_DETAILS_FAILURE_DK:
        case UPDATE_WASHING_DC_DETAILS_FAILURE_DK:
        case DELETE_WASHING_DC_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_WASHING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case WASHING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedWashingDCDetails: {}
            };
        default:
            return state;
    }
};
